export enum ReportEntryCategory {
  Bildung = "Bildung",
  Gesundheit = "Gesundheit",
  Standard = "Standard",
  AsylUndIntegration = "AsylUndIntegration",
  Freizeit = "Freizeit",
  PsychosozialeEntwicklung = "Psychosoziale Entwicklung",
  SoziooekonomischeEntwicklung = "Sozioökonomische Entwicklung",
  Umfeld = "Familiäres Umfeld & soziale Kontakte",
}
